<div class="modal-wrapper">
  <div class="inner-wrapper">
    <ion-text color="dark" class="ion-text-center text">
      <div>{{ question }}</div>
    </ion-text>

    <ion-item class="input-field">
      <ion-label position="floating">{{ inputLabel }}</ion-label>
      <ion-input [type]="inputType" [(ngModel)]="input"></ion-input>
    </ion-item>
    <ion-button
      [disabled]="input.length < 1"
      type="submit"
      class="ion-margin-top right"
      color="primary"
      (click)="this.modalController.dismiss({ input })"
    >
      <ion-text color="light">{{ confirmButtonText }}</ion-text>
    </ion-button>
    <span>
      <ion-button expand="block" type="submit" class="ion-margin-top left" color="primary" (click)="this.modalController.dismiss()"
        ><ion-text color="light">{{ cancelButtonText }}</ion-text></ion-button
      >
    </span>
  </div>
</div>
